import { Action } from 'redux';

import { isSpaceContentsNextPageWithTokenSuccededAction,isSpaceContentsWithTokenRequestSucceededAction } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';

export function contentNextPageTokenReducer(
  previousState: string = null,
  action: Action = null
): string {
  if ((isSpaceContentsWithTokenRequestSucceededAction(action) || isSpaceContentsNextPageWithTokenSuccededAction(action))
       && action?.contentWithToken) {
    return action.contentWithToken.nextPageToken;
  }

  return previousState;
}

